import { render } from "./AccessibilityToolbar.vue?vue&type=template&id=08c60f66&scoped=true"
import script from "./AccessibilityToolbar.vue?vue&type=script&lang=js"
export * from "./AccessibilityToolbar.vue?vue&type=script&lang=js"

import "./AccessibilityToolbar.vue?vue&type=style&index=0&id=08c60f66&scoped=true&lang=css"
import "./AccessibilityToolbar.vue?vue&type=style&index=1&id=08c60f66&lang=css"
import "./AccessibilityToolbar.vue?vue&type=style&index=2&id=08c60f66&scoped=true&lang=css"
import "./AccessibilityToolbar.vue?vue&type=style&index=3&id=08c60f66&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08c60f66"]])

export default __exports__